import React from 'react';
import { Box, Stack, Typography, Chip } from '@mui/material';
import { useSaleCalendar } from './SaleCalendarContext';

const PackagesLegend = () => {
  const { packages } = useSaleCalendar();

  return (
    <Box mt={3}>
      <Typography variant="subtitle1" gutterBottom fontWeight={600}>
        Legenda pakietów:
      </Typography>

      <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
        {packages.map((pkg, idx) => (
          <Stack key={idx} direction="row" alignItems="center" spacing={1}>
            <Typography variant="body2">{pkg.name}</Typography>
            <Chip
              label={pkg.calendar_shortcut}
              sx={{
                backgroundColor: '#6d4c41',
                color: '#fff',
                fontWeight: 500,
                fontSize: '0.875rem',
                height: 28,
                px: 1.5,
                '& .MuiChip-label': {
                  px: 1
                }
              }}
            />
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};

export default PackagesLegend;
